// extracted by css-extract-rspack-plugin
export default {"field":"h77ttXy_0ScOtv54","input":"_TrWy9qQUEgOWHP0","spacerSegment":"Q399_undfIghsh4A","segment":"AXLjfCTiJEYlpeKF"};